import { useAuthStore } from "@/stores/useAuthStore"
import { Entities, Permissions, ROLE_PERMISSIONS } from "@/types/permissions"

export const organizationUserCan = (
  action: Permissions,
  resource: Entities,
): boolean => {
  const roles = useAuthStore.getState().user?.roles

  if (!roles) return false

  return roles.some((role) => {
    const permissions = ROLE_PERMISSIONS[role as keyof typeof ROLE_PERMISSIONS]
    if (!permissions) return false

    const actions = permissions[resource]
    if (!actions) return false

    return actions.includes(action)
  })
}
